function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import { AnimatePresence, useReducedMotion } from "framer-motion";
import React from "react";
import { useIntl } from "../../utils/intl";
import { MainNavigation } from "../Molecules/MainNavigation";
import { Overlay } from "../Molecules/Overlay";
import Pointer from "../Molecules/Pointer";
export function Layout(props) {
    var intl = useIntl();
    var reduceMotion = useReducedMotion();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "snap-y snap-proximity scroll-pt-36 bg-light-grey overflow-hidden selection:bg-purple selection:text-white"
    }, /*#__PURE__*/ React.createElement("a", {
        href: "#main-content",
        className: "skip-link"
    }, intl.formatMessage({
        defaultMessage: "Straight to the content",
        id: "iYUqyr"
    })), /*#__PURE__*/ React.createElement("a", {
        href: "#footer",
        className: "skip-link"
    }, intl.formatMessage({
        defaultMessage: "Straight to the footer",
        id: "HH4CiR"
    })), props.header, /*#__PURE__*/ React.createElement(Overlay, null, function(param) {
        var Link = param.Link;
        return /*#__PURE__*/ React.createElement(MainNavigation, _extends({}, props.headerProps, {
            Link: Link
        }));
    }), /*#__PURE__*/ React.createElement(AnimatePresence, {
        mode: "wait",
        initial: false
    }, props.children ? props.children : /*#__PURE__*/ React.createElement("div", {
        style: {
            minHeight: 300
        }
    })), props.footer), props.pointer && !reduceMotion ? /*#__PURE__*/ React.createElement(Pointer, null) : null);
}
